import { Theme, SxProps } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 'min-content',
    placeContent: 'center',
    [theme.breakpoints.down('md')]: {
      height: '100%',
    },
  },
  fintocLogo: {
    width: 100,
    [theme.breakpoints.down('sm')]: {
      width: 80,
    },
  },
  getnetLogo: {
    width: 128,
    [theme.breakpoints.down('sm')]: {
      width: 90,
    },
  },
  pacLogo: {
    width: 100,
    [theme.breakpoints.down('sm')]: {
      width: 70,
    },
  },
  card: {
    padding: '1.5em',
    paddingInline: '2em',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      margin: 'auto',
      textAlign: 'center',
    },
  },
}));

export const sxStyles = {
  sectionTitle: {
    letterSpacing: 1,
    color: 'text.secondary',
    display: 'block',
    mb: 2,
  } as SxProps<Theme>,

  subscriptionLabelBox: {
    py: 0.5,
  } as SxProps<Theme>,

  formControlLabel: {
    flex: 1,
    m: 0,
  } as SxProps<Theme>,

  activeChip: {
    fontSize: '0.65rem',
    height: 22,
    ml: 1,
  } as SxProps<Theme>,

  newSubButtonContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
  } as SxProps<Theme>,

  warningBox: {
    mt: 5,
    p: 2,
    borderRadius: 2,
    backgroundColor: '#fffbeb',
    border: '1px solid #fde68a',
    display: 'flex',
    gap: 2,
    alignItems: 'center',
  } as SxProps<Theme>,

  warningIcon: {
    fontSize: 20,
    color: '#d97706',
    flexShrink: 0,
  } as SxProps<Theme>,

  warningText: {
    color: '#92400e',
  } as SxProps<Theme>,

  cooldownAlert: {
    mt: 2.5,
    paddingInline: 2.5,
    borderRadius: 2,
    lineHeight: 1,
    fontSize: '0.75rem',
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    '& .MuiAlert-icon': {
      marginRight: 0,
    },
  } as SxProps<Theme>,

  deleteDialogTitle: {
    width: '100%',
    paddingInline: 5,
  } as SxProps<Theme>,

  subscriptionCard: {
    borderRadius: 2,
    mb: 2,
    display: 'flex',
    alignItems: 'center',
    px: 1.5,
    py: 1,
    transition: 'border-color 0.15s, background-color 0.15s',
  } as SxProps<Theme>,

  deleteIconButton: {
    ml: 0.5,
    color: 'text.disabled',
    flexShrink: 0,
  } as SxProps<Theme>,

  newSubButton: {
    width: '100%',
    borderStyle: 'dashed',
    borderRadius: 2,
    py: 1.5,
    color: 'text.primary',
    borderColor: '#bbb',
    textTransform: 'none',
  } as SxProps<Theme>,
};

export default useStyles;
